/* global axios */
import ApiClient from './ApiClient';

class SalesReportAPI extends ApiClient {
  constructor() {
    super('sales_report', { accountScoped: true });
  }

  getReport(filters = {}) {
    return axios.get(this.url, { params: filters });
  }

  downloadPdf(filters = {}) {
    return axios.get(`${this.url}/download_pdf`, {
      params: filters,
      responseType: 'blob',
    });
  }

  emailReport(filters = {}) {
    return axios.post(`${this.url}/email_report`, filters);
  }

  getProviderCatalogs() {
    return axios.get(`${this.url}/provider_catalogs`);
  }

  getProviderRouting() {
    return axios.get(`${this.url}/provider_routing`);
  }

  updateProviderRouting(config) {
    return axios.patch(`${this.url}/provider_routing`, config);
  }

  reassignProvider(payload) {
    return axios.post(`${this.url}/reassign_provider`, payload);
  }

  uploadProviderCatalog(providerId, catalog) {
    const formData = new FormData();
    formData.append('provider_id', providerId);
    formData.append('catalog', catalog);

    return axios.post(`${this.url}/provider_catalog`, formData);
  }

  downloadProviderCatalog(providerId) {
    return axios.get(`${this.url}/provider_catalog`, {
      params: { provider_id: providerId },
      responseType: 'blob',
    });
  }

  deleteProviderCatalog(providerId) {
    return axios.delete(`${this.url}/provider_catalog`, {
      params: { provider_id: providerId },
    });
  }

  markInvoiced(conversationIds) {
    return axios.post(`${this.url}/mark_invoiced`, {
      conversation_ids: conversationIds,
    });
  }

  markPaid(conversationId) {
    return axios.post(`${this.url}/mark_paid`, {
      conversation_id: conversationId,
    });
  }

  updateCommercialRecord(conversationId, record) {
    return axios.patch(`${this.url}/commercial_record`, {
      conversation_id: conversationId,
      record,
    });
  }

  deleteCommercialRecord(conversationId) {
    return axios.delete(`${this.url}/commercial_record`, {
      data: {
        conversation_id: conversationId,
      },
    });
  }
}

export default new SalesReportAPI();
